import { Alert, Box, Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ModalConfirmHiringProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    planName: string;
    insuranceValue: string;
}

export const ModalConfirmHiring = ({
    open,
    onClose,
    onConfirm,
    planName,
    insuranceValue,
}: ModalConfirmHiringProps) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    width: "90%",
                    maxWidth: 400,
                    outline: "none",
                    textAlign: "center",
                }}
            >
                <Stack alignItems="center" spacing={2}>
                    <Box sx={{
                        bgcolor: "rgba(255, 193, 7, 0.1)",
                        p: 1.5,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1
                    }}>
                        <ErrorOutlineIcon sx={{ fontSize: 40, color: "#ffc107" }} />
                    </Box>

                    <Typography variant="h6" fontWeight="700">
                        Confirmar Contratação?
                    </Typography>

                    <Typography variant="body1" color="text.secondary">
                        Deseja seguir a contratação do plano <strong>{planName}</strong>?
                    </Typography>

                    <Alert severity="warning">
                        <Typography variant="body2" color="text.primary">
                            Será iniciada a contratação da garantia. O Seguro Incêndio ({insuranceValue}) terá seu orçamento salvo, e sua contratação deverá ser confirmada após a contratação da garantia.
                        </Typography>
                    </Alert>

                    <Stack direction="row" spacing={2} sx={{ width: "100%", mt: 2 }}>
                        <Button
                            variant="outlined"
                            fullWidth
                            onClick={onClose}
                            sx={{ color: "text.secondary", borderColor: "rgba(0,0,0,0.23)" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={onConfirm}
                        >
                            Confirmar
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};
